/**
 * P167. Derives the signed-in actor's own Super Agent organization id from the
 * real GET /api/backoffice/home accessScopes array - never from a route param,
 * never invented. accessScopes only ever contains scopes the backend has
 * already resolved as active, so no client-side status check is needed on top
 * of this.
 *
 * Returns null for anyone without an owning Super Agent scope (SuperAdmin, PLC,
 * Agent). That is not an error: a SuperAdmin legitimately has no single line of
 * their own, and the Partner Invite screen answers that by asking which Super
 * Agent's letters to show rather than by refusing.
 *
 * The Agent-side twin of this is ../agent/ownership.js - kept separate because
 * the two resolve different scope types and a shared "find my scope" helper is
 * how an Agent id eventually ends up in a Super Agent slot.
 */
export function findOwningSuperAgentOrganizationId(accessScopes) {
  if (!Array.isArray(accessScopes)) {
    return null;
  }

  const ownScope = accessScopes.find(
    (scope) => scope?.roleCode === "SuperAgent" && scope?.scopeType === "SuperAgentOrganization" && Boolean(scope?.scopeId)
  );

  return ownScope?.scopeId ?? null;
}

/** True when this actor is the platform SuperAdmin (Platform-scoped). */
export function isPlatformSuperAdmin(accessScopes) {
  if (!Array.isArray(accessScopes)) {
    return false;
  }

  return accessScopes.some((scope) => scope?.roleCode === "SuperAdmin" && scope?.scopeType === "Platform");
}
